import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateToText, DisplayPaging, RandomId, TextDate } from "components/MyControl";
import ATSApiConnection from 'api_ref/ATSApiConnection';
import Layout4Admin1 from "components/layout/Layout4Admin1";
import moment from "moment";

export default function ListEmail() {
    const api = new ApiConection();
    const atsApi = new ATSApiConnection();

    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    });

    const [search, setSearch] = useState({
        serviceName: '',
        emailTo: '',
        executionDateFrom: moment().format("DD/MM/YYYY"),
        executionDateTo: moment().format("DD/MM/YYYY"),
        page: 1,
        size: 10
    });

    const [paymentStatus, setPaymentStatus] = useState([]);
    const [loading, setLoading] = useState(false);

    const nav = useNavigate();

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;
        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {
        handleSetSearch('page', page_no);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const callApiRegister = async () => {
        setLoading(true);

        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size
            }
        }

        if (search.serviceName != '')
            data.search.serviceName = search.serviceName;

        if (search.emailTo != '')
            data.search.emailTo = search.emailTo;

        if (search.executionDateFrom != '')
            data.search.executionDateFrom = search.executionDateFrom;
        if (search.executionDateTo != '')
            data.search.executionDateTo = search.executionDateTo;

        const response_pagination = await api.postData('api/EmailQueue/pagination', data);
        //debugger;
        if (response_pagination.status == true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }
        const response_result = await api.postData('api/EmailQueue/result', data);

        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
        if (record_end > response_pagination.data.record_count) {
            record_end = response_pagination.data.record_count;
        }

        handleSetDataTable('record_end', record_end);

        setLoading(false);
    }

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                callApiRegister();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search])

    const handleChange = (register_number) => {
        nav(`detail/${register_number}`);
    }
    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">รายการส่งเมล</h6>
                                    <div className="flex-fill">
                                    </div>
                                </div>
                                <div className="d-flex bg-">
                                    <div className="w-100 bg-light p-3">
                                        <Row className="mb-2">
                                            <Col>
                                                <Form.Label>Service Name</Form.Label>
                                                <Form.Control name={'serviceName'} value={search.serviceName} onChange={handleFullSearch} />
                                            </Col>
                                            <Col>
                                                <Form.Label>Email To</Form.Label>
                                                <Form.Control name={'emailTo'} value={search.emailTo} onChange={handleFullSearch} />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <Form.Label>Execution Date</Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text>จาก</InputGroup.Text>
                                                    <TextDate name={'executionDateFrom'} value={search.executionDateFrom} onChange={handleFullSearch} />
                                                    <InputGroup.Text>ถึง</InputGroup.Text>
                                                    <TextDate name={'executionDateTo'} value={search.executionDateTo} onChange={handleFullSearch} />
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                            </div>

                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="table-responsive border rounded">

                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr className={`text-start ${Css.widthEmail}`}>
                                                <th className={`text-center ${Css.widthEmailId}`}>#</th>
                                                <th>ServiceName</th>
                                                <th>Created</th>
                                                <th>EmailFrom</th>
                                                <th>EmailTo</th>
                                                <th>EmailCc</th>
                                                <th>EmailBcc</th>
                                                <th>EmailSubject</th>
                                                <th>HtmlContent</th>
                                                <th>SentAt</th>
                                                <th>ExecutionDate</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj.serviceName}</td>
                                                            <td className="text-start">{obj.created}</td>
                                                            <td className="text-start">{obj.emailFrom}</td>
                                                            <td className="text-start">{obj.emailTo}</td>
                                                            <td className="text-start">{obj.emailCc}</td>
                                                            <td className="text-start">{obj.emailBcc}</td>
                                                            <td className="text-start">{obj.emailSubject}</td>
                                                            <td className="text-start">{obj.htmlContent}</td>
                                                            <td className="text-start">{obj.sentAt}</td>
                                                            <td className="text-start">{obj.executionDate}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}